import React from 'react';
import { RiSearchLine } from '@remixicon/react';
import {
  type IconComponent,
  createFrontendModule,
  PageBlueprint,
  NavItemBlueprint,
} from '@backstage/frontend-plugin-api';
import searchPlugin from '@backstage/plugin-search/alpha';

export const searchPagesModule = createFrontendModule({
  pluginId: 'search',
  extensions: [
    PageBlueprint.make({
      params: {
        path: '/search',
        routeRef: searchPlugin.routes.root,
        title: 'Search',
        loader: async () => {
          const [{ SearchContextProvider }, { default: SearchPage }] =
            await Promise.all([
              import('@backstage/plugin-search-react'),
              import('./search.page'),
            ]);
          return React.createElement(
            SearchContextProvider,
            { initialState: { term: '', types: ['software-catalog'], filters: {} } },
            React.createElement(SearchPage),
          );
        },
      },
    }),
    NavItemBlueprint.make({
      params: {
        title: 'Search',
        icon: RiSearchLine as IconComponent,
        routeRef: searchPlugin.routes.root,
      },
    }),
  ],
});
